import { FormErrors } from 'redux-form';

const validate = (
  values: SearchArmyListParams,
): FormErrors<SearchArmyListParams> => {
  const errors: FormErrors<SearchArmyListParams> = {};

  if (!values.versionId) {
    errors.versionId = 'You must select a version.';
  }

  if (!values.armyId) {
    errors.armyId = 'You mus select an army.';
  }

  if (!values.max || values.max < 0) {
    errors.max = 'You must choose the max.';
  }

  if (values.min == null || values.min < 0) {
    errors.min = 'You must choose the min.';
  }

  return errors;
};
export default validate;

export type SearchArmyListParams = {
  versionId: number;
  armyId: number;
  min: number;
  max: number;
};
